module.exports = __webpack_public_path__ + "img/p1-pic.54c60b1a.jpg";